/* Nordforms faste, realistiske wall-preview scene.

   Baggrunden er et fotografi uden produkt. Kundens aktuelle produkt tegnes i
   et separat lag af City Builder eller rammekonfiguratoren. Derfor kan motiv,
   profil og materiale skifte uden at scene-assetet skifter.

   Lifestyle-fotoets frie ophængningsplan er kalibreret til 120 x 120 cm.
   Det er ikke hele rummets bredde, men den synlige vægflade over skænken,
   som produktet faktisk sammenlignes med. Et værk på 44 x 44 cm bliver
   dermed præcis dobbelt så bredt og højt som 22 x 22 cm, mens 66 x 44 cm
   bliver tre gange så bredt som enkeltkortet. */
(() => {
  'use strict';

  const SCENE_WIDTH_CM = 120;
  const SCENE_HEIGHT_CM = 120;
  const PRODUCT_CENTER_X_CM = 60;
  const PRODUCT_CENTER_Y_CM = 51;

  const positive = (value, fallback) => {
    const number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  };

  function vindue(productWidthCm, productHeightCm) {
    const width = positive(productWidthCm, 22);
    const height = positive(productHeightCm, width);
    return {
      breddeCm: SCENE_WIDTH_CM,
      hoejdeCm: SCENE_HEIGHT_CM,
      venstreCm: -SCENE_WIDTH_CM / 2,
      topCm: -PRODUCT_CENTER_Y_CM,
      bundCm: SCENE_HEIGHT_CM - PRODUCT_CENTER_Y_CM,
      motivVenstrePct: (PRODUCT_CENTER_X_CM - width / 2) / SCENE_WIDTH_CM * 100,
      motivTopPct: (PRODUCT_CENTER_Y_CM - height / 2) / SCENE_HEIGHT_CM * 100,
      motivBreddePct: width / SCENE_WIDTH_CM * 100,
      motivHoejdePct: height / SCENE_HEIGHT_CM * 100
    };
  }

  /* Samme centimeter-model omsat til den konkrete kvadratiske previewflade.
     Begge konfiguratorer bruger denne funktion; de må ikke have egne
     multipliers, minimumsstørrelser eller ankre, som kan drive fra hinanden. */
  function pixels(productWidthCm, productHeightCm, viewportWidthPx, viewportHeightPx) {
    const viewportWidth = positive(viewportWidthPx, 320);
    const viewportHeight = positive(viewportHeightPx, viewportWidth);
    const view = vindue(productWidthCm, productHeightCm);
    return {
      ...view,
      venstrePx: viewportWidth * view.motivVenstrePct / 100,
      topPx: viewportHeight * view.motivTopPct / 100,
      breddePx: viewportWidth * view.motivBreddePct / 100,
      hoejdePx: viewportHeight * view.motivHoejdePct / 100
    };
  }

  /* Et opgivet billed-/kortmaal er aabningen, som kunden koeber motivet i.
     En fysisk ramme ligger uden om den aabning. Begge konfiguratorer bruger
     denne kontrakt, saa 22 x 22 cm med samme profil faar samme ydre maal og
     samme anker i lifestyle-scenen. */
  function product(artworkWidthCm, artworkHeightCm, edgeXCm = 0, edgeYCm = edgeXCm) {
    const artworkWidth = positive(artworkWidthCm, 22);
    const artworkHeight = positive(artworkHeightCm, artworkWidth);
    const edgeX = Math.max(0, Number(edgeXCm) || 0);
    const edgeY = Math.max(0, Number(edgeYCm) || 0);
    return {
      artworkWidthCm: artworkWidth,
      artworkHeightCm: artworkHeight,
      exteriorWidthCm: artworkWidth + edgeX * 2,
      exteriorHeightCm: artworkHeight + edgeY * 2,
      edgeXCm: edgeX,
      edgeYCm: edgeY
    };
  }

  function productPixels(artworkWidthCm, artworkHeightCm, edgeXCm, edgeYCm,
    viewportWidthPx, viewportHeightPx) {
    const dimensions = product(artworkWidthCm, artworkHeightCm, edgeXCm, edgeYCm);
    return {
      ...dimensions,
      artwork: pixels(dimensions.artworkWidthCm, dimensions.artworkHeightCm, viewportWidthPx, viewportHeightPx),
      exterior: pixels(dimensions.exteriorWidthCm, dimensions.exteriorHeightCm, viewportWidthPx, viewportHeightPx)
    };
  }

  function assetUrl(scope = document) {
    const direct = scope?.dataset?.nfWallBackground;
    if (direct) return direct;
    const owner = scope?.querySelector?.('[data-nf-wall-background]')
      || document.querySelector('[data-nf-wall-background]');
    return owner?.dataset?.nfWallBackground || '';
  }

  window.nfVaegScene = Object.freeze({
    vindue,
    pixels,
    product,
    productPixels,
    assetUrl,
    sceneWidthCm: SCENE_WIDTH_CM,
    sceneHeightCm: SCENE_HEIGHT_CM
  });
})();
